export default "__VITE_ASSET__8789aa7c__"